export default function SanitationEntries() {
  return (
    <table id="filetable">
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/sanitation/trash-recycling-wcg-20240910.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Waste Collection Guide
          </a>
        </td>
        <td>09/17/2024</td>
        {/*End File*/}
      </tr>
    </table>
  );
}
